function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["variant", "title", "hasIcon", "iconXlinkHref", "className", "isClosable", "isLoading", "onClose", "dataSpacer", "children", "isClosed"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import { useState, useEffect } from "react";
import classNamesMaker from "classnames";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { MAIN_THEME } from "#library/constants/skeleton";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { Text, TEXT_WEIGHTS, TEXT_TYPES } from "#library/components/Text/Text";
import IconLight from "#library/assets/icons/jds_light.svg";
import IconCheckCircleFull from "#library/assets/icons/jds_checkCircleFull.svg";
import IconWarningFull from "#library/assets/icons/jds_warningFull.svg";
import IconCrossCircleFull from "#library/assets/icons/jds_crossCircleFull.svg";
import IconCross from "#library/assets/icons/jds_cross.svg";
import styles from "./Note.module.css";
export var Note = function Note(_ref) {
  var variant = _ref.variant,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    _ref$hasIcon = _ref.hasIcon,
    hasIcon = _ref$hasIcon === void 0 ? true : _ref$hasIcon,
    _ref$iconXlinkHref = _ref.iconXlinkHref,
    iconXlinkHref = _ref$iconXlinkHref === void 0 ? "" : _ref$iconXlinkHref,
    className = _ref.className,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    dataSpacer = _ref.dataSpacer,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? "" : _ref$children,
    _ref$isClosed = _ref.isClosed,
    propIsClosed = _ref$isClosed === void 0 ? false : _ref$isClosed,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(propIsClosed),
    _useState2 = _slicedToArray(_useState, 2),
    isClosed = _useState2[0],
    setIsClosed = _useState2[1];
  useEffect(function () {
    setIsClosed(propIsClosed);
  }, [propIsClosed]);
  var handleOnClose = function handleOnClose(event) {
    setIsClosed(true);
    onClose(event);
  };
  if (isClosed) {
    return null;
  }
  var noteClassName = classNamesMaker(styles["jds-Note"], _defineProperty({}, styles["jds-Note--loading"], isLoading), _defineProperty({}, styles["jds-Note--primary"], variant === "primary"), _defineProperty({}, styles["jds-Note--neutral"], variant === "neutral"), _defineProperty({}, styles["jds-Note--success"], variant === "success"), _defineProperty({}, styles["jds-Note--warning"], variant === "warning"), _defineProperty({}, styles["jds-Note--error"], variant === "error"), className);
  var iconClassName = classNamesMaker(_defineProperty({}, styles["jds-Note__icon--success"], variant === "success"), _defineProperty({}, styles["jds-Note__icon--warning"], variant === "warning"), _defineProperty({}, styles["jds-Note__icon--error"], variant === "error"));
  var getIconXLinkHref = function getIconXLinkHref() {
    if (iconXlinkHref) return iconXlinkHref;
    var iconVariants = {
      primary: "#".concat(IconLight.id),
      neutral: "#".concat(IconLight.id),
      success: "#".concat(IconCheckCircleFull.id),
      warning: "#".concat(IconWarningFull.id),
      error: "#".concat(IconCrossCircleFull.id)
    };
    return iconVariants[variant];
  };
  return /*#__PURE__*/React.createElement(SkeletonTheme, MAIN_THEME, /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
    className: noteClassName,
    "aria-atomic": "true",
    "aria-busy": isLoading,
    "aria-live": "polite",
    "data-spacer": dataSpacer
  }), hasIcon && !isLoading && /*#__PURE__*/React.createElement(Icon, {
    className: iconClassName,
    xlinkHref: getIconXLinkHref(),
    size: ICON_SIZES.MEDIUM
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Note__body"]
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: styles["jds-Note__body__title"],
    weight: TEXT_WEIGHTS.BOLD,
    resetSpacing: true
  }, isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "40%"
  }) : title), /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    type: TEXT_TYPES.SMALL,
    resetSpacing: true
  }, children && (isLoading ? /*#__PURE__*/React.createElement(Skeleton, null) : children))), isClosable && !isLoading && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles["jds-Note__closeButton"],
    "aria-label": "close",
    onClick: handleOnClose
  }, /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZES.SMALL,
    xlinkHref: "#".concat(IconCross.id),
    "aria-hidden": "true"
  }))));
};